import { useAlertStore } from '@/stores/alert.store';
import type { AlertOptions, AlertResult, AlertButton } from '@/stores/alert.store';

class AlertService {
  async fire<T = string, B extends string = string>(
    options: AlertOptions<B> = {},
  ): Promise<AlertResult<T, B>> {
    const alertStore = useAlertStore();
    return alertStore.showAlert<T, B>(options as any);
  }
}

// Create singleton instance
export const Alert = new AlertService();

// Export the service class for testing
export { AlertService };
export type { AlertOptions, AlertResult, AlertButton };
